module.exports = __webpack_public_path__ + "assets/mustache.0e18fa42.svg";